import React, { useCallback } from 'react';
import { LobbyBottomNav } from './lobbyHubShared';
import { LobbyTablesBlock } from './LobbyTablesBlock';
import { LobbyHomeKataHeading, LobbyHomePlayTilesRow, LobbyHomeTablesModeRow } from './LobbySekaHomeArt';
import { useLobbySekaTables } from '../hooks/useLobbySekaTables';
import { HUB_SOCKET_PHASE } from '../realtime/connectionUx';
import './Lobby.css';

function Lobby({
  user,
  socket,
  hubSocketPhase = HUB_SOCKET_PHASE.IDLE,
  onJoinTable,
  onOpenWallet,
  onOpenLocal,
  onOpenOnline,
  onOpenBelot,
  onOpenGifts,
  onOpenFriends,
  giftsNavBadgeCount = 0,
  friendsNavBadgeCount = 0,
  /** Открыть OnlineLobby и присоединиться к столу как по «Войти». */
  onOpenHubJoinOnlineLobby,
  /** Создать комнату: только онлайн-лобби + модалка (без create на hub). */
  onOpenOnlineCreateRoom,
}) {
  const tableState = useLobbySekaTables({
    socket,
    user,
    onJoinTable,
    lobbyMode: 'seka',
    lobbyReturnView: 'lobby',
  });

  const handleModeTileClick = useCallback(
    (tile) => {
      if (tile.id === 'local') onOpenLocal();
      else if (tile.id === 'online') onOpenOnline();
    },
    [onOpenLocal, onOpenOnline]
  );

  return (
    <div className="lobby-mp mx-auto flex min-h-0 w-full max-w-[500px] flex-1 flex-col overflow-x-hidden overflow-y-visible px-3 pt-1.5">
      <div
        className="lobby-mp-scroll safe-scroll-top min-h-0 flex-1 overflow-y-auto overscroll-y-contain px-1 pb-[var(--lobby-bottom-nav-h)] pt-0.5 [scroll-padding-bottom:var(--lobby-bottom-nav-h)] sm:px-1.5"
        tabIndex={-1}
      >
        <LobbyHomeKataHeading />
        <LobbyHomeTablesModeRow onOpenBelot={onOpenBelot} />
        <LobbyHomePlayTilesRow socket={socket} onTileClick={handleModeTileClick} />

        <LobbyTablesBlock
          mode="seka"
          toolbarVisual="homeArt"
          user={user}
          onJoinTable={onJoinTable}
          onPlayThroughOnlineLobby={
            onOpenHubJoinOnlineLobby
              ? (table) =>
                  onOpenHubJoinOnlineLobby({
                    roomCode: String(table?.id ?? '')
                      .trim()
                      .toUpperCase(),
                    isPrivate: Boolean(table?.isPrivate),
                    origin: 'lobby',
                  })
              : undefined
          }
          hubSocketPhase={hubSocketPhase}
          onOpenCreateRoom={() => onOpenOnlineCreateRoom?.()}
          {...tableState}
        />
      </div>

      {/* Нижняя панель: подарки друзьям | создать комнату | друзья */}
      <LobbyBottomNav
        mode="seka"
        visual="homeArt"
        onOpenGifts={onOpenGifts}
        onOpenFriends={onOpenFriends}
        onOpenCreateRoom={() => onOpenOnlineCreateRoom?.()}
        giftsNavBadgeCount={giftsNavBadgeCount}
        friendsNavBadgeCount={friendsNavBadgeCount}
      />
    </div>
  );
}

export default Lobby;
